import { FieldType } from '@pmp/api';

export const PROCURATION_FEES_LIST_NAMES: FieldType[] = [FieldType.PROCURATION_FEES, FieldType.PROCURATION_FEE_RULES];
